/* Syoat: Autoplay only the visible, active product-gallery video. */
(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 959px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialize(root) {
    if (!root || root.dataset.videoFirstInitialized === 'true') return;

    var videos = Array.from(root.querySelectorAll('[data-autoplay-video] video'));
    if (!videos.length) return;

    root.dataset.videoFirstInitialized = 'true';

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var conserveData = Boolean(connection && connection.saveData);
    var observer;

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.preload = 'metadata';
    });

    function visibleGallery() {
      return root.querySelector(
        mobileQuery.matches
          ? '.product__media-container.below-mobile'
          : '.product__media-container.above-mobile'
      );
    }

    function activeVideo() {
      var gallery = visibleGallery();
      if (!gallery) return null;

      var mediaItem = gallery.querySelector('.product__media-item:not(.hidden)');

      if (mobileQuery.matches) {
        var slider = gallery.querySelector('.scroll-slider__slider');
        if (slider && slider.children.length) {
          var galleryRect = slider.getBoundingClientRect();
          var galleryCenter = galleryRect.left + galleryRect.width / 2;
          var closestDistance = Infinity;

          Array.from(slider.children).forEach(function (slide) {
            var slideRect = slide.getBoundingClientRect();
            var slideCenter = slideRect.left + slideRect.width / 2;
            var distance = Math.abs(slideCenter - galleryCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              mediaItem = slide;
            }
          });
        }
      }

      return mediaItem ? mediaItem.querySelector('[data-autoplay-video] video') : null;
    }

    function pauseOthers(except) {
      videos.forEach(function (video) {
        if (video !== except) video.pause();
      });
    }

    function syncPlayback() {
      var video = activeVideo();
      pauseOthers(video);

      if (!video || document.hidden || reducedMotionQuery.matches || conserveData) {
        pauseOthers(null);
        return;
      }

      var gallery = video.closest('.product__media-container');
      if (!gallery || gallery.getClientRects().length === 0) return;

      var rect = video.getBoundingClientRect();
      var inViewport = rect.bottom > 0 && rect.top < window.innerHeight;
      if (!inViewport) return;

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          // Native controls and the poster remain available when autoplay is blocked.
        });
      }
    }

    function scheduleSync() {
      window.requestAnimationFrame(syncPlayback);
    }

    document.addEventListener('scroll-slider-' + root.dataset.scrollerId + ':slide-changed', scheduleSync);
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-product-thumbnail]')) {
        window.setTimeout(syncPlayback, 0);
      }
    });
    document.addEventListener('visibilitychange', syncPlayback);
    mobileQuery.addEventListener('change', syncPlayback);
    reducedMotionQuery.addEventListener('change', syncPlayback);

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(syncPlayback, { threshold: 0.15 });
      videos.forEach(function (video) { observer.observe(video); });
    }

    window.setTimeout(syncPlayback, 0);
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-video-first-gallery]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
